import type { TrackingEvent } from '../types/TrackingEvents'

/**
 * Id of the calendar group (row) that a tracking event is rendered in on the Games tab.
 * With "Group by Live Event Blueprint" on, events that have a blueprint are grouped per
 * (typeId, blueprintId); all other events are grouped by typeId.
 */
export const getTrackingEventGroupId = (event: Pick<TrackingEvent, 'typeId' | 'blueprintEvolutionData'>, groupByBlueprint: boolean): string => {
  const blueprintId = event.blueprintEvolutionData?.blueprintId || undefined

  return groupByBlueprint && blueprintId !== undefined ? `${event.typeId}_${blueprintId}` : event.typeId
}

/**
 * DOM id of a calendar group row, as rendered by the calendar group components.
 */
export const getCalendarGroupElementId = (gameId: string, groupId: string): string => `${gameId}-${groupId}`
